export default {
  planFullData: state => state?.billingPlans?.find(plan=>plan.id===state.billing.planId)
};